<svelte:options tag={null} />

<script lang="ts">
  import type { LoaderSize, LoaderTheme } from './loader.types';

  export let size: LoaderSize;
  export let theme: LoaderTheme;
  export let text: string;

  function setClasses(size: LoaderSize, theme: LoaderTheme) {
    const classes = ['mc-loader'];

    if (size) {
      classes.push(`mc-loader--${size}`);
    }

    if (theme) {
      classes.push(`mc-loader--${theme}`);
    }

    return classes.join(' ');
  }

  function setViewBox(size: LoaderSize) {
    let viewBox: string;

    switch (size) {
      case 's':
        viewBox = '0 0 24 24';
        break;
      case 'l':
        viewBox = '0 0 64 64';
        break;
      default:
        viewBox = '0 0 32 32';
    }

    return viewBox;
  }

  function setCircleRadius(size: LoaderSize) {
    let circleRadius: number;

    switch (size) {
      case 's':
        circleRadius = 6;
        break;
      case 'l':
        circleRadius = 19;
        break;
      default:
        circleRadius = 9;
    }

    return circleRadius;
  }
</script>

<div class="{setClasses(size, theme)} {$$props.class}">
  <span class="mc-loader__spinner">
    <svg
      class="mc-loader__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={setViewBox(size)}
    >
      <circle
        class="mc-loader__path"
        cx="50%"
        cy="50%"
        r={setCircleRadius(size)}
      />
    </svg>
  </span>

  {#if text}
    <span class="mc-loader__text">
      {text}
    </span>
  {/if}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.loader';
</style>
